<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Bpost verhuisdienst</h1>
      <p>
        Als u gaat verhuizen, dan doet u er verstandig om gebruik te maken van
        de Bpost verhuisdienst. Als u deze service heeft aangevraagd, worden
        belangrijke instanties en bedrijven ingelicht over uw adreswijziging.
        Deze organisaties kunt u zelf selecteren. De Bpost verhuisdienst zorgt
        er vervolgens desgewenst voor dat de post die daarna geadresseerd is aan
        uw oude adres, wordt doorgestuurd naar uw nieuwe adres. U bepaalt zelf
        hoe lang dit gebeurt (met een maximum van 24 maanden). Zelfs als u
        voortaan in het buitenland woont, kunt u van deze mogelijkheid gebruik
        maken.
      </p>

      <h2>Kosten en voorwaarden</h2>
      <p>
        De hoogte van het bedrag dat u moet betalen is afhankelijk van het
        aantal maanden dat u gebruik wenst te maken van de service. Buiten
        België liggen de tarieven van deze dienst wel een pak hoger. Met de
        Bpost verhuisdienst wordt in principe alle post doorgestuurd, al zijn er
        enkele uitzonderingen zoals pensioenen, krantabonnementen, pakketten en
        huis-aan-huis reclame. Voor deze zaken dient u zelf uw leverancier op de
        hoogte te brengen van uw verhuis. Daarnaast wordt enkel geadresseerde
        briefwisseling op naam doorgestuurd naar het nieuwe adres.
      </p>
      <p>
        Wilt u graag precies weten wat de Bpost verhuisdienst kost en welke
        uitzonderingen er worden gemaakt? Dan kunt u terecht op de website van
        Bpost.
      </p>

      <h2>Bpost verhuisservice en offertes: nooit te vroeg!</h2>
      <p>
        Ook wanneer uw verhuizing pas over een aantal maanden gepland staat, is
        het niet te vroeg om te beginnen met de voorbereidingen. Begin dus vast
        met het regelen van zaken, zoals het aanvragen van de Bpost
        verhuisdienst, maar bijvoorbeeld eveneens met het inpakken van dozen.
        Ook met het vergelijken van offertes van verhuisfirma’s kunt u het best
        ruim van tevoren beginnen, zodat u op tijd weet met welke verhuizers u
        een overeenkomst kunt aangaan. Voorkom een hoop geregel op het laatste
        moment en vraag vandaag nog gratis offertes aan van verhuisfirma’s in uw
        regio!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Bpost verhuisdienst: maak het uzelf niet moeilijker dan nodig is!',
      headDescription:
        'Gaat u verhuizen? Vergelijk gratis offertes op Verhuisvergelijker.be en lees de tips op de website! Lees bijvoorbeeld alles over de Bpost verhuisdienst.',
    }
  },
}
</script>
